import type { BannerContent } from "./global-banner.types";

/**
 * Gets the appropriate banner content based on current local time
 * @param now - Current date (defaults to new Date() for easier testing)
 * @returns Banner content configuration or null if no active promotion
 */
export function getBannerContent(now: Date = new Date()): BannerContent | null {
  const year = now.getFullYear();
  const currentTime = now.getTime();

  const isInRange = (
    startMonth: number,
    startDay: number,
    startHour: number,
    startMinute: number,
    endMonth: number,
    endDay: number,
    endHour: number,
    endMinute: number,
  ) => {
    const start = new Date(year, startMonth, startDay, startHour, startMinute);
    const end = new Date(year, endMonth, endDay, endHour, endMinute);

    return currentTime >= start.getTime() && currentTime <= end.getTime();
  };

  // Best of Winter Layers: 9th Jan 00:00 - 11th Jan 23:59
  const isWinterLayersPeriod = isInRange(0, 9, 0, 0, 0, 11, 23, 59);

  // Further Reductions: 12th Jan 00:00 - 14th Jan 23:59
  const isFurtherReductionsPeriod = isInRange(0, 12, 0, 0, 0, 14, 23, 59);

  // Final Reductions: 15th Jan 00:00 - 21st Jan 23:59
  const isFinalReductionsPeriod = isInRange(0, 15, 0, 0, 0, 21, 23, 59);

  if (isFinalReductionsPeriod) {
    return {
      title: "FINAL REDUCTIONS",
      subtitle: "NOW UP TO 70% OFF",
      text: "",
      code: "",
      colorScheme: "red",
      clickable: true,
      href: "/topshop/category/sale?cid=53075",
    };
  }

  if (isFurtherReductionsPeriod) {
    return {
      title: "FURTHER REDUCTIONS WHILST STOCK LASTS",
      subtitle: "SHOP SALE NOW",
      text: "",
      code: "",
      colorScheme: "red",
      clickable: true,
      href: "/topshop/category/sale?cid=53075",
    };
  }

  if (isWinterLayersPeriod) {
    return {
      title: "BEST OF WINTER LAYERS",
      subtitle: "SHOP THE CURATED EDIT NOW",
      text: "",
      code: "",
      colorScheme: "black",
      clickable: true,
      href: "/topshop/category/sale?cid=52905",
    };
  }

  return null;
}
